import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleCallback, consumeReturnPath } from '../lib/auth';

export default function AuthCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    handleCallback(window.location.search)
      .then((ok) => {
        if (ok) navigate(consumeReturnPath() || '/campaigns', { replace: true });
        else setError('Authentication failed. Please try again.');
      })
      .catch(() => setError('Failed to exchange the code for a token.'));
  }, [navigate]);

  return (
    <div className="h-full flex items-center justify-center">
      <div className="text-center">
        {error ? (
          <>
            <div className="text-3xl mb-2">⚠️</div>
            <p className="text-sm text-rose-700">{error}</p>
            <a href="/" className="text-sm text-brand-600 underline mt-2 inline-block">Back</a>
          </>
        ) : (
          <>
            <div className="h-8 w-8 mx-auto rounded-full border-2 border-brand-500 border-t-transparent animate-spin" />
            <p className="text-sm text-slate-500 mt-3">Authenticating…</p>
          </>
        )}
      </div>
    </div>
  );
}
